import EmailPresetFormPage from "./emailPresetFormPage";

const UpdateEmailPreset = () => <EmailPresetFormPage mode="edit" />;

export default UpdateEmailPreset;
